
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';

@Component({
  mixins: [Themeable],
})
export default class AliasDialog extends Vue {
  @Prop() public domain: string;

  public visible: boolean = true;

  public aliasDomain: string = '';

  public excludeActions: string[] = ['email'];


  public get message(): string {
    return `Create "${this.domain}" Alias`;
  }

  public create(): void {
    this.$emit('createAlias', this.aliasDomain, this.excludeActions);
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }

  public excludeAction(action: string, value: boolean): void {
    if (value) {
      this.excludeActions = this.excludeActions.filter((a) => a !== action);

      return;
    }

    this.excludeActions.push(action);
  }
}
